export default __webpack_public_path__ + "static/media/glasses10.d2b5fd69.jpeg";